import logoImage from './assets/images/logo-lab-hoh.svg';
import logoSymbolImage from './assets/images/logo-lab-hoh-symbol.svg';

export const dashboardConfig = {
  appSlug: 'lab-hoh-dashboard',
  logoImage: logoImage,
  logoSymbolImage: logoSymbolImage,
  appTitle: 'LAB HOH Dashboard'
};

export const dashboardThemeColors = {
  light: {
    primary: '#36a0dd',
    secondary: '#1a458c',
    accent: '#7dc243',
    error: '#b71c1c',
    success: '#7dc243',
    lightPrimary: '#e0f0fa'
  }
};

export const apiConfig = {
  baseUrlHohSearchEngine:
    process.env.NODE_ENV === 'production'
      ? 'https://dvg-search-prd.t0qg3mdkloj92.us-east-1.cs.amazonlightsail.com/search/webresources'
      : 'https://dvg-search-dev.t0qg3mdkloj92.us-east-1.cs.amazonlightsail.com/search/webresources',
  baseUrlApi: process.env.NODE_ENV === 'production' ? 'https://api.labhoh.app' : 'https://api-test.labhoh.app',
  baseUrlApiDvg: process.env.NODE_ENV === 'production' ? 'https://api.dvgapp.org' : 'https://test.dvgapp.org',
  baseUrlContentApi: 'https://tourist.dvgapp.org'
};
